import { render, staticRenderFns } from "./RentalObjectTenancies.vue?vue&type=template&id=1a974fb2&"
import script from "./RentalObjectTenancies.vue?vue&type=script&lang=js&"
export * from "./RentalObjectTenancies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports